import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form'
import type { EnumField } from '../../types'

export interface EnumFeatureInputFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  field: EnumField
  label: string
}

export const EnumInputField = <T extends FieldValues>({ field, label, ...props }: EnumFeatureInputFieldProps<T>) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={(form) => (
        <FormControl sx={{ minWidth: 160 }} {...props}>
          <InputLabel htmlFor={`enum-select-field`} id={`enum-select-field`}>
            {label}
          </InputLabel>
          <Select
            native
            labelId={`enum-select-field`}
            value={form.field.value}
            label={label}
            data-testid={`enum-select-field-${field.name}`}
            onChange={(event) => form.field.onChange(event.target.value as PathValue<T, Path<T>>)}
          >
            {field.allowedValues.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Select>
        </FormControl>
      )}
    />
  )
}
